module.exports = __webpack_public_path__ + "static/media/blog.83f53daa.png";